'use client';

import { useState } from 'react';
import { Layers, Package } from 'lucide-react';

interface InventoryItemThumbnailProps {
  imageUrl?: string | null;
  name: string;
  itemType?: string | null;
  isDark?: boolean;
  sizeClassName?: string;
  roundedClassName?: string;
  className?: string;
  objectFit?: 'cover' | 'contain';
}

export default function InventoryItemThumbnail({
  imageUrl,
  name,
  itemType = 'product',
  isDark = false,
  sizeClassName = 'h-12 w-12',
  roundedClassName = 'rounded-lg',
  className = '',
  objectFit = 'cover',
}: InventoryItemThumbnailProps) {
  const [hasError, setHasError] = useState(false);

  const showImage = Boolean(imageUrl) && !hasError;
  const PlaceholderIcon = itemType === 'service' ? Layers : Package;

  return (
    <div
      className={[
        'shrink-0 overflow-hidden border flex items-center justify-center',
        sizeClassName,
        roundedClassName,
        className,
        isDark ? 'border-gray-700 bg-gray-800' : 'border-gray-200 bg-gray-50',
      ].join(' ')}
    >
      {showImage ? (
        // eslint-disable-next-line @next/next/no-img-element -- inventory product images come from direct cloud-storage URLs and are rendered as lightweight thumbnails in dense picker/list UIs
        <img
          src={imageUrl!}
          alt={name}
          loading="lazy"
          onError={() => setHasError(true)}
          className={`h-full w-full ${objectFit === 'contain' ? 'object-contain bg-white' : 'object-cover'}`}
        />
      ) : (
        <PlaceholderIcon className={`h-5 w-5 ${isDark ? 'text-gray-500' : 'text-gray-400'}`} />
      )}
    </div>
  );
}